/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type NetworkMemberResponseKind = typeof NetworkMemberResponseKind[keyof typeof NetworkMemberResponseKind];


export const NetworkMemberResponseKind = {
  user: 'user',
  external: 'external',
} as const;
